<template>
<div class="chapter">
<div class="inner_page">
<p class="h1"><a id="title"></a><a id="page_i"></a><a id="page_ii"><strong>HERBACEOUS PERENNIAL PLANTS</strong></a></p><a id="page_ii">
<p class="h1sub"><strong>A Treatise on their Identification, Culture, and Garden Attributes</strong></p>
<p class="edition">Third Edition</p>
<p class="author"><strong>Allan M. Armitage</strong><br/>University of Georgia</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?155b3771